export default __webpack_public_path__ + "static/media/p2p.773406e9.jpg";